function downloadBase64(base64: string, filename: string, mimeType: string): void {
  const bytes = atob(base64);
  const buffer = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    buffer[i] = bytes.charCodeAt(i);
  }
  const blob = new Blob([buffer], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadBase64Pdf(base64: string, filename: string): void {
  const clean = base64.replace(/^data:application\/pdf;base64,/, "");
  downloadBase64(clean, filename, "application/pdf");
}

export function downloadBase64Zip(base64: string, filename: string): void {
  downloadBase64(base64, filename, "application/zip");
}

export function openBase64Pdf(base64: string, filename: string, windowRef?: Window | null): void {
  const clean = base64.replace(/^data:application\/pdf;base64,/, "");
  const bytes = atob(clean);
  const buffer = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    buffer[i] = bytes.charCodeAt(i);
  }
  const blob = new Blob([buffer], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const targetWindow = windowRef || window.open("", "_blank");
  if (targetWindow) {
    try {
      targetWindow.document.title = filename;
      targetWindow.document.body.innerHTML = "";

      const iframe = targetWindow.document.createElement("iframe");
      iframe.src = url;
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.style.position = "absolute";
      iframe.style.top = "0";
      iframe.style.left = "0";

      targetWindow.document.body.style.margin = "0";
      targetWindow.document.body.style.padding = "0";
      targetWindow.document.body.style.overflow = "hidden";
      targetWindow.document.body.appendChild(iframe);
      targetWindow.document.close();
    } catch (e) {
      targetWindow.location.href = url;
    }
  }
}

